module.exports = __webpack_public_path__ + "static/media/freedial-free.c49d42ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/freedial-free.svg
// module id = 492
// module chunks = 11